import { Component, OnInit } from '@angular/core';
import { NavigationEmitterService } from '../../services/NavigationEmitterService';
import { LocalStorage } from 'finpass-angular-services';

@Component({
  selector: 'fpc-navigation-profile',
  template: `<fui-profile-box-mobile [open]="open">
  <i class="fa fa-2x fa-user-circle" user-icon></i>
  <span user-name>OlÃ¡, {{userName}}</span>
  <ng-container profile-items>
    <ng-container *ngIf="!hasPermission('operator')">
      <fui-profile-box-mobile-item (click)="goToEditProfile()">
        <span profile-item>Editar conta</span>
      </fui-profile-box-mobile-item>
      <fui-profile-box-mobile-item (click)="openChangePassword()">
        <span profile-item>Alterar senha</span>
      </fui-profile-box-mobile-item>
      <fui-profile-box-mobile-item (click)="logout()">
        <span profile-item>Sair</span>
      </fui-profile-box-mobile-item>
    </ng-container>
    <ng-container *ngIf="hasPermission('operator')">
      <fui-profile-box-mobile-item (click)="logout()">
        <span profile-item>Sair</span>
      </fui-profile-box-mobile-item>
    </ng-container>
  </ng-container>
</fui-profile-box-mobile>
`,
  styles: [``]
})
export class NavigationProfileComponent implements OnInit {

  userName: any;
  open = false;

  constructor(private navigationEmitter: NavigationEmitterService,
    private localStorage:LocalStorage) { }

  ngOnInit() {
    this.toggleListener();
    this.userName = (this.localStorage.get('loginInfo') || {}).name;
  }

  hasPermission(typeUser: String) {
    return false;
  }

  goToEditProfile() {
    this.notifyNavigation('goToEditProfile');
  }

  openChangePassword() {
    this.notifyNavigation('openChangePassword');
  }

  logout() {
    this.notifyNavigation('logout');
  }

  notifyNavigation(method) {
    this.navigationEmitter.notify({
      to: 'navigation',
      method
    })
  }

  toggleListener() {
    this.navigationEmitter.data.subscribe(data => {
      if (data === 'profile-box') {
        this.open = !this.open;
      }
    });
  }
  
  close() {
    this.open = false;
  }

}
